import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IFilter } from '@shared/interfaces/IFilter';
import { FilterService } from '@shared/services/filter.service';
import { flatten } from 'lodash-es';
import { GuardService } from '@shared/services';

@Component({
    selector: 'app-search-bar-filter',
    templateUrl: './search-bar-filter.component.html',
    styleUrls: ['./search-bar-filter.component.scss'],
    standalone: false
})
export class SearchBarFilterComponent implements OnInit {
    @Input() filters: Array<IFilter | IFilter[]>;
    @Input() filterService: FilterService;
    @Output() changeFilter = new EventEmitter<IFilter>();

    constructor(private guard: GuardService) {}

    private _singleFilters: IFilter[];

    get singleFilters(): IFilter[] {
        return this._singleFilters
            ? this._singleFilters
            : this.filters
              ? (this._singleFilters = this.filters.filter(
                    e => !(e instanceof Array) && e.searchFor && (!e.admin || (e.admin && this.guard.isAdmin))
                ) as IFilter[])
              : [];
    }

    private _arrayFilters: IFilter[][];

    get arrayFilters(): IFilter[][] {
        return this._arrayFilters
            ? this._arrayFilters
            : this.filters
              ? (this._arrayFilters = this.filters
                    .filter(e => e instanceof Array && !e.some(a => a.groupBy || a.sortBy))
                    .map((e: IFilter[]) => e.filter(a => !a.admin || (a.admin && this.guard.isAdmin))) as IFilter[][])
              : [];
    }

    private _arrayGroupBy: IFilter[][];

    get arrayGroupBy(): IFilter[][] {
        return this._arrayGroupBy
            ? this._arrayGroupBy
            : this.filters
              ? (this._arrayGroupBy = this.filters
                    .filter(e => e instanceof Array && e.some(a => a.groupBy))
                    .map((e: IFilter[]) => e.filter(a => !a.admin || (a.admin && this.guard.isAdmin))) as IFilter[][])
              : [];
    }

    private _sortBy: IFilter[];

    get sortBy(): IFilter[] {
        return this._sortBy
            ? this._sortBy
            : this.filters
              ? (this._sortBy = this.filters.filter(
                    e => !(e instanceof Array) && e.sortBy && (!e.admin || (e.admin && this.guard.isAdmin))
                ) as IFilter[])
              : [];
    }

    ngOnInit(): void {
        const filter = this.filters.filter(e => !(e instanceof Array)) as IFilter[];
        if (filter.length && !filter.some(e => e.selected)) {
            filter[0].selected = true;
        }
    }

    selectedValue(filter: IFilter[]) {
        const element = filter.find(e => e.selected);
        return element ? element : filter[0];
    }

    selectFilter(item: IFilter) {
        const filter = this.filters.filter(e => !(e instanceof Array)) as IFilter[];
        filter.forEach(e => (e.selected = false));
        item.selected = true;
        this.changeFilter.emit(item);
    }

    selectArrayFilter({ value }: { value: IFilter }) {
        const filter = (flatten(this.filters.filter(e => e instanceof Array)) as IFilter[]).filter(
            e => e.searchFor === value.searchFor
        );
        filter.forEach(e => (e.selected = false));
        value.selected = true;
        this.changeFilter.emit(value);
    }

    selectSort(item: IFilter) {
        this.sortBy.filter(e => e !== item).forEach(e => (e.value = null));
        item.value = item.value === 'ASC' ? 'DESC' : item.value === 'DESC' ? null : 'ASC';
        this.changeFilter.emit(item);
    }

    getArgsOfPlaceholder(item: string | { key: string; values: any }): any {
        return (item as { key: string; values: any }).values ? (item as { key: string; values: any }).values : {};
    }

    getPlaceholder(item: string | { key: string; values: any }): string {
        return (item as { key: string; values: any }).key
            ? (item as { key: string; values: any }).key
            : (item as string);
    }
}
